import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Form, Input, InputNumber, Select, Space, Popconfirm, message } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import api from '../api'
import useStore from '../store'

export default function AccountsPage() {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [form] = Form.useForm()
  const { user } = useStore()
  const canEdit = user?.role !== 'readonly'

  const load = () => api.get('/accounts').then(setData)
  useEffect(() => { load() }, [])

  const openModal = (record = null) => {
    setEditing(record)
    form.setFieldsValue(record || { currency: 'RMB', initial_balance: 0 })
    setOpen(true)
  }

  const onSave = async () => {
    const values = await form.validateFields()
    try {
      if (editing) { await api.put(`/accounts/${editing.id}`, values) }
      else { await api.post('/accounts', values) }
      message.success('保存成功')
      setOpen(false)
      load()
    } catch (err) { message.error(err) }
  }

  const columns = [
    { title: '账户名称', dataIndex: 'name' },
    { title: '类型', dataIndex: 'type', width: 100 },
    { title: '币种', dataIndex: 'currency', width: 80 },
    { title: '期初余额', dataIndex: 'initial_balance', render: v => parseFloat(v).toLocaleString() },
    { title: '期初日期', dataIndex: 'initial_date', width: 110 },
    { title: '备注', dataIndex: 'note', ellipsis: true },
    canEdit && {
      title: '操作', width: 100, render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => openModal(r)} />
          <Popconfirm title="确认删除？" onConfirm={async () => { await api.delete(`/accounts/${r.id}`); load() }}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ].filter(Boolean)

  return (
    <div>
      {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()} style={{ marginBottom: 16 }}>新增账户</Button>}
      <Table dataSource={data} columns={columns} rowKey="id" />
      <Modal title={editing ? '编辑账户' : '新增账户'} open={open} onOk={onSave} onCancel={() => setOpen(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="账户名称" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="type" label="账户类型" rules={[{ required: true }]}><Input placeholder="银行/现金/支付宝等" /></Form.Item>
          <Form.Item name="currency" label="币种" rules={[{ required: true }]}>
            <Select><Select.Option value="RMB">人民币(RMB)</Select.Option><Select.Option value="VND">越南盾(VND)</Select.Option><Select.Option value="USD">美元(USD)</Select.Option></Select>
          </Form.Item>
          <Form.Item name="initial_balance" label="期初余额" rules={[{ required: true }]}><InputNumber style={{ width: '100%' }} /></Form.Item>
          <Form.Item name="initial_date" label="期初日期(YYYY-MM-DD)" rules={[{ required: true }]}><Input placeholder="2024-01-01" /></Form.Item>
          <Form.Item name="note" label="备注"><Input.TextArea rows={2} /></Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
